import initialState from './initialstate';
import _ from 'lodash';
import utility from '../util/utilityfunctions';
import * as types from '../actions/actiontypes';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function GlobalStateReducer(state = initialState.globalState, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT: {
			return {
				...state,
				engagementCountryId: action.response.countryId,
				engServiceLineId: action.response.serviceLineId,
				engSubServiceLineId: action.response.subServiceLineId,
				sdmFeatureDisable: utility.getSDMFeatureRestricted({
					restrictedCountryIds: state.restrictedCountryIdsForSDM,
					validServiceLines: state.validServiceLinesForSDM,
					countryId: action.response.countryId,
					engServiceLineId: action.response.serviceLineId,
					engSubServiceLineId: action.response.subServiceLineId
				}),
				sdmFlagLoaded: state.restrictedCountryIdsForSDM && action.response.countryId
			};
		}
		case types.START_OFFLINE_SYNC: {
			return {
				...state,
				docHelperInitialized: true
			};
		}

		case types.GET_CONFIGURATIONS: {
			return {
				...state,
				restrictedCountryIdsForSDM: _.get(action, 'response.features.restrictedCountryIdsForSDM'),
				restrictedCountryIdsForIndividualView: _.get(action, 'response.features.restrictedCountryIdsForIndividualView'),
				validServiceLinesForSDM: _.get(action, 'response.features.validServiceLinesForSDM'),
				sdmFeatureDisable: utility.getSDMFeatureRestricted({
					restrictedCountryIds: _.get(action, 'response.features.restrictedCountryIdsForSDM'),
					validServiceLines: _.get(action, 'response.features.validServiceLinesForSDM'),
					countryId: state.engagementCountryId,
					engServiceLineId: state.engServiceLineId,
					engSubServiceLineId: state.engSubServiceLineId
				}),
				serviceGatewayEnabled: !_.isEmpty(action.response.features?.serviceGatewayBase), // if serviceGate is there then we need to navigate to Service Gateway
				sdmFlagLoaded: action.response.features?.restrictedCountryIdsForSDM && state.engagementCountryId,
				isAutomationHubEnabled: !!_.get(action, 'response.features.automationHub'),
				sendCanvasFormToPrimary:
					action.response && action.response.features && action.response.features.sendCanvasFormToPrimary
			};
		}

		default:
			return state;
	}
}

export function getIsAutomationHubEnabled(state) {
	return state.globalState?.isAutomationHubEnabled;
}
